import { BaseFieldClass } from './baseField.class'

import { ITinymceField } from '@/types/serverField.type'

export class TinymceFieldClass extends BaseFieldClass {
  declare fieldValue: string
  declare initialValue: string

  constructor (field: ITinymceField) {
    super(field)
    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value as string | null)
    this.fieldValue = this.prepareValue(value as string | null)
  }

  prepareValue (value: string | null): string {
    return value ?? ''
  }

  getValue () {
    return {
      [this.name]: this.fieldValue
    }
  }

  isEmpty () {
    return !this.value || this.value === '<p></p>'
  }

  appendToFormData (formData: FormData): void {
    formData.append(this.name, String(this.fieldValue ?? ''))
  }

  getFilterValue () {
    return this.fieldValue
  }
}
